import script from "./Agreement.vue?vue&type=script&setup=true&lang=ts"
export * from "./Agreement.vue?vue&type=script&setup=true&lang=ts"

import "./Agreement.vue?vue&type=style&index=0&id=1cd03219&scoped=true&lang=scss"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cd03219"]])

export default __exports__